import React from 'react';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';

const FormFileUploadUploadingIcon = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    const updatedClasses = classes.push('w-icon-file-upload-uploading');

    return (
      <svg
        {...generateAttributes(attributes, updatedClasses)}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
        aria-hidden="true"
      >
        <path
          fill="currentColor"
          opacity=".2"
          d="M15 30a15 15 0 1 1 0-30 15 15 0 0 1 0 30zm0-3a12 12 0 1 0 0-24 12 12 0 0 0 0 24z"
        />
        <path
          fill="currentColor"
          opacity=".75"
          d="M0 15A15 15 0 0 1 15 0v3A12 12 0 0 0 3 15H0z"
        >
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            dur="0.6s"
            from="0 15 15"
            repeatCount="indefinite"
            to="360 15 15"
            type="rotate"
          />
        </path>
      </svg>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Icon',
  showEmpty: false,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Star')),
  },
  render: FormFileUploadUploadingIcon,
  fields: {},
});

export default config;
